import React from "react";
import { useSelector } from "react-redux";

const UserProfile = (props) => {
  const { user } = useSelector(({ auth }) => auth);

  return (
    <div className="gx-flex-row gx-align-items-center gx-mb-4 gx-avatar-row">
      <div>
        <div style={{ fontSize: 16, fontWeight: "bold" }}>{user?.name}</div>
        <div>{user?.userType}</div>
      </div>
    </div>
  );
};

export default UserProfile;
